///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { GridModule } from '@progress/kendo-angular-grid';
import { IntlModule } from '@progress/kendo-angular-intl';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { KbDataFormComponent } from './components/data-form/data-form.component';
import { KbDataPanelComponent } from './components/data-panel/data-panel.component';
import { KbGridComponent } from './components/grid/grid.component';
import { KbAutoCompleteComponent } from './components/auto-complete/auto-complete.component';
import { KbNumericTextBoxComponent } from './components/numeric-text-box/numeric-text-box.component';
import { KbTextBoxComponent } from './components/text-box/text-box.component';
import { KbDisabledTextBoxComponent } from './components/disabled-text-box/disabled-text-box.component';
import { KbEmailTextBoxComponent } from './components/email-text-box/email-text-box.component';
import { KbImageComponent } from './components/image/image.component';
import { KbPasswordTextBoxComponent } from './components/password-text-box/password-text-box.component';
import { KbTextAreaComponent } from './components/text-area/text-area.component';
import { KbUrlTextBoxComponent } from './components/url-text-box/url-text-box.component';
import { KbCurrencyTextBoxComponent } from './components/currency-text-box/currency-text-box.component';
import { KbSliderComponent } from './components/slider/slider.component';
import { KbMaskedTextBoxComponent } from './components/masked-text-box/masked-text-box.component';
import { KbPhoneTextBoxComponent } from './components/phone-text-box/phone-text-box.component';
import { KbIntegerTextBoxComponent } from './components/integer-text-box/integer-text-box.component';
import { KbPercentTextBoxComponent } from './components/percent-text-box/percent-text-box.component';
import { KbPercentValueTextBoxComponent } from './components/percent-value-text-box/percent-value-text-box.component';
import { KbLabelComponent } from './components/label/label.component';
import { KbCheckBoxComponent } from './components/check-box/check-box.component';
import { KbButtonComponent } from './components/button/button.component';
import { KbRadioButtonListComponent } from './components/radio-button-list/radio-button-list.component';
import { KbBooleanRadioButtonListComponent } from './components/boolean-radio-button-list/boolean-radio-button-list.component';
import { KbCalendarComponent } from './components/calendar/calendar.component';
import { KbDatePickerComponent } from './components/date-picker/date-picker.component';
import { KbTimePickerComponent } from './components/time-picker/time-picker.component';
import { KbDateTimePickerComponent } from './components/date-time-picker/date-time-picker.component';
import { KbDropDownListComponent } from './components/drop-down-list/drop-down-list.component';
import { KbCustomHtmlComponent } from './components/custom-html/custom-html.component';
import { KbTabStripComponent } from './components/tab-strip/tab-strip.component';
import { KbComboBoxComponent } from './components/combo-box/combo-box.component';
import { KbAreaChartsComponent } from './components/area-charts/area-charts.component';
import { KbBarChartsComponent } from './components/bar-charts/bar-charts.component';
import { KbLineChartsComponent } from './components/line-charts/line-charts.component';
import { KbDonutChartsComponent } from './components/donut-charts/donut-charts.component';
import { KbPieChartsComponent } from './components/pie-charts/pie-charts.component';
import { KbLanguagesDropDownComponent } from './components/languages-drop-down/languages-drop-down.component';
import { KbExpanderComponent } from './components/expander/expander.component';
import { ValidationService } from './services/validation.service';
import { ShowForRolesDirective } from './directives/show-for-roles.directive';
import { FormatValuePipe } from './pipes/format-value.pipe';
import { KbNavigationPanelBarComponent } from './components/navigation-panel-bar/navigation-panel-bar.component';
import { KbUserDropDownComponent } from './components/user-drop-down/user-drop-down.component';

import '@progress/kendo-angular-intl/locales/af/all';
import '@progress/kendo-angular-intl/locales/am/all';
import '@progress/kendo-angular-intl/locales/ar/all';
import '@progress/kendo-angular-intl/locales/az/all';
import '@progress/kendo-angular-intl/locales/be/all';
import '@progress/kendo-angular-intl/locales/bg/all';
import '@progress/kendo-angular-intl/locales/bn/all';
import '@progress/kendo-angular-intl/locales/bs/all';
import '@progress/kendo-angular-intl/locales/ca/all';
import '@progress/kendo-angular-intl/locales/de/all';
import '@progress/kendo-angular-intl/locales/en/all';
import '@progress/kendo-angular-intl/locales/el/all';
import '@progress/kendo-angular-intl/locales/es/all';
import '@progress/kendo-angular-intl/locales/fr/all';
import '@progress/kendo-angular-intl/locales/it/all';
import '@progress/kendo-angular-intl/locales/ja/all';
import '@progress/kendo-angular-intl/locales/pt/all';
import '@progress/kendo-angular-intl/locales/ru/all';
import '@progress/kendo-angular-intl/locales/tr/all';

import 'hammerjs';

export const config: NgModule = {
    declarations: [
        KbTextBoxComponent,
        KbDataFormComponent,
        KbDataPanelComponent,
        KbGridComponent,
        KbAutoCompleteComponent,
        KbNumericTextBoxComponent,
        KbCurrencyTextBoxComponent,
        KbIntegerTextBoxComponent,
        KbPercentTextBoxComponent,
        KbPercentValueTextBoxComponent,
        KbDisabledTextBoxComponent,
        KbEmailTextBoxComponent,
        KbImageComponent,
        KbPasswordTextBoxComponent,
        KbTextAreaComponent,
        KbUrlTextBoxComponent,
        KbLabelComponent,
        KbCheckBoxComponent,
        KbButtonComponent,
        KbMaskedTextBoxComponent,
        KbPhoneTextBoxComponent,
        KbRadioButtonListComponent,
        KbBooleanRadioButtonListComponent,
        KbSliderComponent,
        KbCalendarComponent,
        KbDatePickerComponent,
        KbTimePickerComponent,
        KbDateTimePickerComponent,
        KbDropDownListComponent,
        KbCustomHtmlComponent,
        KbTabStripComponent,
        KbComboBoxComponent,
        KbExpanderComponent,
        KbAreaChartsComponent,
        KbBarChartsComponent,
        KbLineChartsComponent,
        KbDonutChartsComponent,
        KbPieChartsComponent,
        KbLanguagesDropDownComponent,
        KbNavigationPanelBarComponent,
        KbUserDropDownComponent,
        ShowForRolesDirective,
        FormatValuePipe
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        GridModule,
        DialogsModule,
        TranslateModule,
        KbGridComponent,
        KbTextBoxComponent,
        KbDataFormComponent,
        KbDataPanelComponent,
        KbAutoCompleteComponent,
        KbNumericTextBoxComponent,
        KbCurrencyTextBoxComponent,
        KbIntegerTextBoxComponent,
        KbPercentTextBoxComponent,
        KbPercentValueTextBoxComponent,
        KbDisabledTextBoxComponent,
        KbEmailTextBoxComponent,
        KbImageComponent,
        KbPasswordTextBoxComponent,
        KbTextAreaComponent,
        KbUrlTextBoxComponent,
        KbLabelComponent,
        KbCheckBoxComponent,
        KbButtonComponent,
        KbMaskedTextBoxComponent,
        KbPhoneTextBoxComponent,
        KbRadioButtonListComponent,
        KbBooleanRadioButtonListComponent,
        KbSliderComponent,
        KbCalendarComponent,
        KbDatePickerComponent,
        KbTimePickerComponent,
        KbDateTimePickerComponent,
        KbButtonComponent,
        KbDropDownListComponent,
        KbCustomHtmlComponent,
        KbComboBoxComponent,
        KbTabStripComponent,
        KbExpanderComponent,
        KbAreaChartsComponent,
        KbBarChartsComponent,
        KbLineChartsComponent,
        KbDonutChartsComponent,
        KbPieChartsComponent,
        KbLanguagesDropDownComponent,
        KbNavigationPanelBarComponent,
        KbUserDropDownComponent,
        ShowForRolesDirective,
        FormatValuePipe
    ],
    imports: [
        CommonModule,
        GridModule,
        TranslateModule,
        ReactiveFormsModule,
        FormsModule,
        IntlModule,
        InputsModule,
        ButtonsModule,
        DateInputsModule,
        DropDownsModule,
        ChartsModule,
        LabelModule,
        LayoutModule,
        DialogsModule,
        RouterModule
    ],
    providers: [
        ValidationService
    ]
};



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/shared/shared.config.ts